<template>
    <Modal v-model:visible="visible" :backdrop="true">
        <template v-slot:header>
            <div>
                <h2 class="text-lg font-bold">Aggiungi riga di pagamento</h2>
            </div>
        </template>
        <template v-slot:main>
            <div class="flex-grow pt-5 grid grid-cols-2 gap-3">
                <div class="flex flex-col mb-3 col-span-2">
                    <Field field_name="Tipo Effetto" :required="!tipoEffettoAutocomplete?.selection"
                           :errors="getErrors('tipo_effetto_id')"
                           placeholder="Tipo Effetto">
                        <VueMultiselect
                            :loading="tipoEffettoAutocomplete.isLoading"
                            :options="tipoEffettoAutocomplete.options"
                            v-model="tipoEffettoAutocomplete.selection"
                            internal
                            :close-on-select="true" :clear-on-select="true"
                            track-by="RDT00_CODEFFETTO" label="RDT00_DESCEFFETTO"
                            class="next-vue-multiselect-single"
                            placeholder="Tipo Effetto"
                            deselectLabel="Deseleziona"
                            selectedLabel="Selezionato"
                            selectLabel="Seleziona">
                            <template v-slot:noResult>Nessun elemento trovato.</template>
                        </VueMultiselect>
                    </Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Data scadenza" :required="!int_data_scadenza"
                           v-model="int_data_scadenza"
                           type="date"
                           :errors="getErrors('data_scadenza')"></Field>
                </div>
                <div class="flex flex-col mb-3">
                    <Field field_name="Valore" :required="!int_valore" v-model="int_valore" type="number"
                           :inputAttrs="{step:0.01}"
                           :errors="getErrors('valore')"></Field>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="flex justify-end pt-3">
                <NextButton variant="outline-secondary"
                            @click="$emit('update:visible', false)"
                            class="col-start-3 py-2 px-4">
                    Chiudi
                </NextButton>
                <NextButton variant="primary"
                            @click="save"
                            :disabled="loading"
                            class="ml-4 py-2 px-4 flex items-center">
                    <Spinner v-show="loading" class="w-4 h-4 mr-4"></Spinner>
                    {{ id ? 'Modifica' : 'Aggiungi' }}
                </NextButton>
            </div>
        </template>
    </Modal>
</template>

<script lang="ts">
import {Options, setup, Vue} from 'vue-class-component';
import Modal from "@/components/Modal.vue";
import NextButton from "@/components/NextButton.vue";
import NextEditor from "@/components/NextEditor.vue";
import Field from "@/components/Field.vue";
import Autocomplete from "@/setup/Autocomplete";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import Select from "@/components/Select.vue";
import tipoEffettoManager from "../api/TipoEffetto";
import Spinner from "@/components/Spinner.vue";

@Options({
    name: 'ModalRigaPagamento',
    components: {
        Spinner,
        Select,
        Field,
        NextEditor,
        Modal,
        NextButton
    },
    props: {
        id: String,
        data_scadenza: String,
        tipo_effetto_id: [Number, String],
        valore: [Number, String],
        visible: {
            type: Boolean,
            default: true
        },
        errors: {
            type: Object,
            required: false
        },
        loading: Boolean
    }
})
export default class ModalOdv extends Vue {
    sottoprogetto_id!: any
    cliente_id!: any
    errors!: any
    int_id = ''
    int_data_scadenza = ''
    int_tipo_effetto_id = ''
    int_valore = ''

    id!: string
    data_scadenza!: string
    tipo_effetto_id!: string
    valore!: string

    tipoEffettoAutocomplete: any = setup(() => Autocomplete(tipoEffettoManager))

    created() {
        this.tipoEffettoAutocomplete.search('', 0)
    }

    @Watch('$props', {deep: true})
    props() {
        this.int_id = this.id
        this.int_data_scadenza = this.data_scadenza
        this.int_tipo_effetto_id = this.tipo_effetto_id
        this.int_valore = this.valore
        this.tipoEffettoAutocomplete.selection = this.tipoEffettoAutocomplete.options.find((e: any) => e.RDT00_CODEFFETTO == this.tipo_effetto_id)
        if(this.tipoEffettoAutocomplete.selection === undefined){
            this.tipoEffettoAutocomplete.selection = this.tipoEffettoAutocomplete.options.find((e: any) => e.RDT00_DESCEFFETTO.toLowerCase() == 'bonifico')
            this.int_tipo_effetto_id = this.tipoEffettoAutocomplete.selection?.RDT00_CODEFFETTO || ''
        }
    }


    @Watch('tipoEffettoAutocomplete.selection')
    azienda(new_value: any, old: any) {
        this.int_tipo_effetto_id = new_value?.RDT00_CODEFFETTO || new_value
    }

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    save() {
        this.$emit('update:data_scadenza', this.int_data_scadenza);
        this.$emit('update:tipo_effetto_id', this.int_tipo_effetto_id);
        this.$emit('update:valore', this.int_valore);
        this.$emit('save')
    }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
